import api from "./core";

const basePath = "api/portal/Paya";

export default {
  addPaymentMethod(patientId, data) {
    return api.post(`${basePath}/patient/${patientId}/payment-method`, data);
  }
};
